<template>
<div class="pageWithdrawAccount">  
  <XR-edit-head titleText="提现账户" :rightButtonShow="editButtonShow" ref="head" @editEvent="editEvent" @completeEvent="completeEvent" ></XR-edit-head>
  <div :style="'margin-bottom:'+ height + 'px'">
  <mu-list class="account-info" v-for="bankItem in bankList" :key="bankItem.bid">
    <mu-list-item :title="bankItem.bankname" :describeText="bankItem.bankno" @click="itemSelect(bankItem.bid)">
     <mu-icon  value=":fa fa-alipay" slot="left" v-if="mode=='normal' && bankItem.bankname =='支付宝'" />
      <mu-icon  value=":fa fa-jianshe" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='建设银行'" />
      <mu-icon  value=":fa fa-gongshang" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='工商银行'" />
      <mu-icon  value=":fa fa-zhongguo" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='中国银行'" />
      <mu-icon  value=":fa fa-nongye" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='农业银行'" />
      <mu-icon  value=":fa fa-mingsheng" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='民生银行'" />
      <mu-icon  value=":fa fa-jiaotong" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='交通银行'" />
      <mu-icon  value=":fa fa-zhaoshang" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='招商银行'" />
      <mu-icon  value=":fa fa-guangfa" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='广发银行'" />
      <mu-icon  value=":fa fa-pingan" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='平安银行'" />
      <mu-icon  value=":fa fa-xingye" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='兴业银行'" />
      <mu-icon  value=":fa fa-guangda" slot="left" v-else-if="mode=='normal' && bankItem.bankname =='中国光大银行'" />
      <mu-icon  value=":fa fa-zhongguo" slot="left" v-else-if="mode=='normal' && bankItem.bankname == '财付通'" />
       <mu-icon  value=":fa fa-zhongguo" slot="left" v-else-if="mode=='normal' && bankItem.bankname == ''" />
       <mu-icon  value=":fa fa-alipay" slot="left" v-if="mode=='select' && bankItem.bankname =='支付宝'" />
      <mu-icon  value=":fa fa-jianshe" slot="left" v-else-if="mode=='select' && bankItem.bankname =='建设银行'" />
      <mu-icon  value=":fa fa-gongshang" slot="left" v-else-if="mode=='select' && bankItem.bankname =='工商银行'" />
      <mu-icon  value=":fa fa-zhongguo" slot="left" v-else-if="mode=='select' && bankItem.bankname =='中国银行'" />
      <mu-icon  value=":fa fa-nongye" slot="left" v-else-if="mode=='select' && bankItem.bankname =='农业银行'" />
      <mu-icon  value=":fa fa-mingsheng" slot="left" v-else-if="mode=='select' && bankItem.bankname =='民生银行'" />
      <mu-icon  value=":fa fa-jiaotong" slot="left" v-else-if="mode=='select' && bankItem.bankname =='交通银行'" />
      <mu-icon  value=":fa fa-zhaoshang" slot="left" v-else-if="mode=='select' && bankItem.bankname =='招商银行'" />
      <mu-icon  value=":fa fa-guangfa" slot="left" v-else-if="mode=='select' && bankItem.bankname =='广发银行'" />
      <mu-icon  value=":fa fa-pingan" slot="left" v-else-if="mode=='select' && bankItem.bankname =='平安银行'" />
      <mu-icon  value=":fa fa-xingye" slot="left" v-else-if="mode=='select' && bankItem.bankname =='兴业银行'" />
      <mu-icon  value=":fa fa-guangda" slot="left" v-else-if="mode=='select' && bankItem.bankname =='中国光大银行'" />
      <mu-icon  value=":fa fa-zhongguo" slot="left" v-else-if="mode=='select' && bankItem.bankname == '财付通'" />
       <mu-icon  value=":fa fa-zhongguo" slot="left" v-else-if="mode=='select' && bankItem.bankname == ''" />
      <mu-checkbox class="cart-chk" :nativeValue="bankItem.bid" v-model="checkList" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-check-circle" slot="left" v-if="mode=='edit'" />
	  
      <router-link :to="'/usercenter/withdrawAccountEdit?bankId='+bankItem.bid" v-if="mode=='normal'" slot="right">
        <mu-icon value=":fa fa-angle-right"/>
      </router-link>
    </mu-list-item>	
  </mu-list>
  </div>
  <div class="bottom-bar" v-if="mode =='edit'">
    <mu-row >
      <mu-col width="100" tablet="100" desktop="100">        
        <mu-checkbox v-model="isChkAll" label="" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-check-circle" @change="chkAll()" class="cart-all-chk"/>
        <mu-flat-button class="operatorBtn" @click="delBank()" label="删除"></mu-flat-button>
      </mu-col>
    </mu-row>
  </div>


  <XR-toast ref="XRtoast"></XR-toast>
  <XR-PageTip ref="XRPageTip"></XR-PageTip>
  
  <mu-float-button icon=":fa fa-plus" @click="goTo('/usercenter/withdrawAccountEdit')" class="btn-cs-add" primary v-if="mode!='edit'" />
</div>

</template>
<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data () {
    return {
      mode: this.$route.query.mode?this.$route.query.mode:'normal', //如果mode=normal，则代表正常，如果mode=select，则代表选择模式，选中即跳转回去
      PayPopup : false,
      editButtonShow: true,
      checkList:[],
      isChkAll: false,
      checkAllList:[],
      bankList:[],
	  height:0
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load('加载中...')
    this.getBankList()
  },
  methods: {
    getBankList: function () {      
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetMemberBankList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.editButtonShow =false;
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.hide()
          ths.bankList = res.Data
          if(res.Data && res.Data.length>0){
            for(var i=0; i< ths.bankList.length;i++){
              ths.checkAllList.push(ths.bankList[i].bid)
            }
          }
          ths.checkList=[]
          if(ths.bankList && ths.bankList.length>0){            
            ths.editButtonShow =true;
            ths.$refs.XRPageTip.initTip()
          }else{            
            ths.editButtonShow =false;
            ths.$refs.XRPageTip.ShowEmpty('暂无数据')
          }
        }
      })      
    },
    itemSelect:function(bankId){
      if(this.mode == "select"){
        window.sessionStorage.setItem('_xr_select_bank', bankId)
        this.$router.goBack()
      }
    },
    getSmsCode: function(){
      this.$refs.XRtoast.show('获取中')
    },
     open () {
      this.PayPopup = true
    },
    close (position) {
      this.PayPopup = false
    },     
    goTo:function(url){
      this.$router.push(url)
    },
    editEvent: function(){
      this.mode='edit';
	  this.height=56;
    },
    completeEvent: function(){
	  this.mode='normal';
	  this.height=0;
	  this.delBank();
    },
    chkAll: function(){
      if(!this.isChkAll){
        this.checkList = this.checkAllList
      }else {
        this.checkList = []
      }
    },
    delBank: function(){
      if(this.checkList.length==0){
          this.$refs.XRtoast.failed('请选择要删除的账户',true)    
          return
      }
	  

      var ths = this; 
      ths.icon = ''
      ths.$refs.XRtoast.load('处理中', true)
      ths.$post(
        "/Shop/UserServer/BankDeleteBatch",
        JSON.stringify({id:this.checkList.join(',')})
      ).then(function(res) {
        if(!res.IsSuccess){  
          ths.$refs.XRtoast.failed(res.Msg,true)        
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{
          ths.$refs.XRtoast.success(res.Msg,true)
          ths.getBankList()   
        }
      })      
    }
  }
}

</script>
<style>
.pageWithdrawAccount .login-form {
}
.pageWithdrawAccount .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.pageWithdrawAccount .notice{
  font-size: 12px;
}
.pageWithdrawAccount .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}


.pageWithdrawAccount .balance-info{
  background: white;
  line-height: 26px;
  padding: 10px;
}
.pageWithdrawAccount .account-info{
  background: white;
  margin-top: 10px;
}
.pageWithdrawAccount .withdraw-money{
  margin-top: 10px;
  background: white;
  padding: 20px 0;
}
.pageWithdrawAccount .btn-div{
  text-align: center;
  padding: 20px 0;
}
.pageWithdrawAccount .btn-div .goWithdraw{
  width: 90%;
  height: 50px;
}

.pageWithdrawAccountPayPopup{
  width: 100%;
}
.pageWithdrawAccountPayPopup .title{
  font-size: 16px;
  text-align: center;
}
.pageWithdrawAccountPayPopup .withdrawResult{
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
}
.pageWithdrawAccountPayPopup .submit{
  height: 50px;
}

.pageWithdrawAccount .btn-cs-add{
  position: fixed;
  bottom: 60px;
  right: 20px;
}


.pageWithdrawAccount .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
}
.pageWithdrawAccount .bottom-bar .cart-all-chk{
  float: left;
  width: 24px;
  height: 24px;
  margin: 16px 0 16px 10px;
}
.pageWithdrawAccount .bottom-bar .operatorBtn{
  float: left;
  height: 56px;
  line-height: 56px;
  font-size: 12px;
}
.pageWithdrawAccount .mu-list .fa-angle-right{
  color: #757575;
}
.fa-pingan:before {
    content: "\F401";
    padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/withdrawAccount.vue